import zones01to10 from './data/radioZones01to10';
import zones11to20 from './data/radioZones11to20';
import zones21to30 from './data/radioZones21to30';
import zones31to40 from './data/radioZones31to40';
import zones41to50 from './data/radioZones41to50';
import zones51to55 from './data/radioZones51to55';

import freq01to10 from './data/radioFreq01to10';
import freq11to12 from './data/radioFreq11to12';
import freq13to14 from './data/radioFreq13to14';
import freq15to16 from './data/radioFreq15to16';
import freq17to18 from './data/radioFreq17to18';
import freq19to20 from './data/radioFreq19to20';
import freq21to22 from './data/radioFreq21to22';
import freq23 from './data/radioFreq23';
import freq24to26 from './data/radioFreq24to26';
import freq27to30 from './data/radioFreq27to30';
import freq31to33 from './data/radioFreq31to33';
import freq34to35 from './data/radioFreq34to35';
import freq36to40 from './data/radioFreq36to40';
import freq41to42 from './data/radioFreq41to42';
import freq43to44 from './data/radioFreq43to44';
import freq45to50 from './data/radioFreq45to50';
import freq51to55 from './data/radioFreq51to55';

export const RADIO_REFERENCE_SOURCE = '2023 CAL FIRE KNG M150 Statewide Channel Plan · FINAL 03-13-23';
export const RADIO_REFERENCE_NOTE = 'Full bank/channel reference. RX/TX frequencies, tones and published notes are stored in the app for offline search.';

function parseDetailIndex(raw) {
  const index = new Map();
  String(raw || '').split('\n').filter(Boolean).forEach(line => {
    const [key, rxFreq = '', rxTone = '', txFreq = '', txTone = '', power = '', wideNarrow = '', ...noteParts] = line.split('|');
    const detail = {
      rxFreq,
      rxTone,
      txFreq,
      txTone,
      power,
      wideNarrow,
      notes: noteParts.join('|'),
    };
    const list = index.get(key) || [];
    list.push(detail);
    index.set(key, list);
  });
  return index;
}

const FREQUENCY_RAW = [
  freq01to10,
  freq11to12,
  freq13to14,
  freq15to16,
  freq17to18,
  freq19to20,
  freq21to22,
  freq23,
  freq24to26,
  freq27to30,
  freq31to33,
  freq34to35,
  freq36to40,
  freq41to42,
  freq43to44,
  freq45to50,
  freq51to55,
].join('\n');

const DETAIL_INDEX = parseDetailIndex(FREQUENCY_RAW);

function parseZone(line) {
  const [zoneText, name, description, channelText = ''] = String(line || '').split('|');
  const zone = Number(zoneText);
  const occurrences = new Map();
  const channels = channelText
    ? channelText.split(';').filter(Boolean).map(entry => {
        const split = entry.indexOf('=');
        const channel = Number(entry.slice(0, split));
        const display = entry.slice(split + 1);
        const key = `${zone}.${channel}`;
        const occurrence = occurrences.get(key) || 0;
        occurrences.set(key, occurrence + 1);
        const detail = DETAIL_INDEX.get(key)?.[occurrence] || {};
        return {
          channel,
          display,
          rxFreq: detail.rxFreq || '',
          rxTone: detail.rxTone || '',
          txFreq: detail.txFreq || '',
          txTone: detail.txTone || '',
          power: detail.power || '',
          wideNarrow: detail.wideNarrow || '',
          notes: detail.notes || '',
        };
      })
    : [];
  return {
    zone,
    name,
    description,
    channels,
  };
}

const RAW = [zones01to10, zones11to20, zones21to30, zones31to40, zones41to50, zones51to55].join('\n');

export const RADIO_ZONES = RAW.split('\n').filter(Boolean).map(parseZone);
